import { ControlType, FormFieldBase } from './form-field-base.model';

export class CheckBoxFormField extends FormFieldBase<boolean> {
  controlType: ControlType = 'checkbox';
}
